import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function LogoCarousel({ logos, className = "" }) {
  const { t } = useTranslation();
  const [paused, setPaused] = useState(false);
  const label = t(paused ? "carousel.resume" : "carousel.pause");
  return (
    <button type="button" className={`container mx-auto flex flex-row carousel-container logo-carousel cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white ${className}`}
      aria-label={`${label}: ${logos.map(logo => logo.name).join(", ")}`}
      title={label} onClick={() => setPaused(value => !value)}>
      <span className="carousel-track top-0 flex flex-row justify-center gap-16 fill-white" style={{ animationPlayState: paused ? "paused" : "running" }} aria-hidden="true">
        {[...logos, ...logos].map((logo, index) => (
          <img key={index} src={logo.img} alt="" draggable="false"
            className={`w-1/8 carousel-card object-contain opacity-90 hover:scale-110 hover:opacity-100 transition-all duration-300 ${index >= logos.length ? "carousel-copy" : ""}`} />
        ))}
      </span>
      <span className="sr-only">{label}</span>
    </button>
  );
}
